import { useI18n } from "vue-i18n";
// Arco国际化
import A_zhCN from "@arco-design/web-vue/es/locale/lang/zh-cn";
import A_enUS from "@arco-design/web-vue/es/locale/lang/en-us";
// El国际化
import E_zhCN from "element-plus/dist/locale/zh-cn.mjs";
import E_enUS from "element-plus/dist/locale/en.mjs";
// dayjs国际化
import dayjs from "dayjs";
import D_zhCN from "dayjs/locale/zh-cn";
import D_enUS from "dayjs/locale/en";

export default {
    data() {
        return {
            locales: {
                Arco: {
                    "zh-cn": A_zhCN,
                    "en-us": A_enUS,
                },
                Elem: {
                    "zh-cn": E_zhCN,
                    "en-us": E_enUS,
                },
                Dayjs: {
                    "zh-cn": D_zhCN,
                    "en-us": D_enUS,
                },
            },
        };
    },
    methods: {
        locale(type = "Arco") {
            const i18n = useI18n();
            const value = i18n.locale.value;
            dayjs.locale(this.locales.Dayjs[value]);
            return this.locales[type][value];
        },
    },
}